const ENABLED = import.meta.env.VITE_PERF_LOG_UI === 'true';

export function uiPerfEnabled() {
  return ENABLED;
}

export function uiPerfLog(label, data) {
  if (!ENABLED) return;
  console.log(`[UI_PERF] ${label}`, data ?? '');
}
